import { Injectable } from '@angular/core';
import { IonicErrorHandler } from 'ionic-angular';
import { isNil, get, kebabCase } from 'lodash';

@Injectable()
export class ErrorHandlerProvider extends IonicErrorHandler {

 handleError(error: any) {
    // Since Sentry is loaded via CDN setup we need to make sure it actually is available
    //
    if ( ( window as any ).Sentry ) {
      (window as any ).Sentry.captureException(error);
    }

    super.handleError(error);
  }
}



// WEBPACK FOOTER //
// ./src/providers/errorhandler.ts